<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M14,6C13.07,6,12.29,6.64,12.07,7.5C12.07,7.5,9.93,7.5,9.93,7.5C9.71,6.64,8.93,6,8,6C7.07,6,6.29,6.64,6.07,7.5C6.07,7.5,3.93,7.5,3.93,7.5C3.71,6.64,2.93,6,2,6C0.9,6,0,6.9,0,8C0,9.1,0.9,10,2,10C2.93,10,3.71,9.36,3.93,8.5C3.93,8.5,6.06,8.5,6.06,8.5C6.29,9.36,7.07,10,8,10C8.93,10,9.71,9.36,9.93,8.5C9.93,8.5,12.06,8.5,12.06,8.5C12.28,9.36,13.06,10,13.99,10C15.09,10,15.99,9.1,15.99,8C16,6.9,15.1,6,14,6C14,6,14,6,14,6Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LayoutLinear',
} as DefineComponent
</script>
